import { createContext } from 'react'

import { UserSession } from '../types'

export const UserSessionContext = createContext<UserSession>(null)
